import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, IconButton } from "@mui/material";
import { GenericImageGalleryProps } from "@command-center-app/index";
import { imageGallery } from "./styles/commonStyles";
import { Key } from "react";

const GenericImageGallery: React.FC<GenericImageGalleryProps> = ({
  imagelist,
  onClick,
}) => {
  const NO_IMAGE_SRC = "/assets/images/no-image.png";
  const defaultImage =
    imagelist.find((item: { isDefault: any }) => item.isDefault)?.url ||
    imagelist[0]?.url ||
    NO_IMAGE_SRC;
  const otherImages = imagelist.filter(
    (item: { isDefault: any }) => !item.isDefault
  );

  return (
    <Box sx={imageGallery}>
      <Box sx={imageGallery.imageContainer}>
        <IconButton
          disableRipple
          sx={{ zIndex: "100", float: "right" }}
          onClick={onClick}
        >
          <Box>
            <AddCircleOutlineIcon />
          </Box>
        </IconButton>
        <img
          src={defaultImage}
          alt="default-img"
          style={imageGallery.defaultImageStyle}
        />
      </Box>
      <Box sx={imageGallery.thumbnailContainer}>
        {otherImages
          .slice(0, 2)
          .map((image: { url: any }, index: Key | null | undefined) => (
            <img
              key={index}
              src={image.url || NO_IMAGE_SRC}
              alt={`thumb-${index}`}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                cursor: "pointer",
                border: "1px solid #E5E7E8",
              }}
            />
          ))}
        {otherImages.length > 2 && (
          <Box
            sx={{
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#F5F5F6",
              cursor: "pointer",
              border: "1px solid #E5E7E8",
            }}
          >
            +{otherImages.length - 2}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GenericImageGallery;
